import {
  type SettingsPropsParametricSelector,
  TargetSelector,
  combinedSettingsSelector,
  createShallowEqualSelector,
  getSettingValueSelector
} from "@client/selectors";
import React from "react";

export const makeCloseButtonStyleSelector = (): SettingsPropsParametricSelector => {
  const settingsSelector = combinedSettingsSelector(TargetSelector.Entity, [
    { name: "iconColor", path: "closeButton", prop: "iconColor", type: "color" },
    { name: "iconSize", path: "closeButton", prop: "iconSize" }
  ]);

  return createShallowEqualSelector(
    [settingsSelector],
    (settings): React.CSSProperties => ({
      color: settings.iconColor,
      fontSize: settings.iconSize
    })
  );
};

const stylePropsSelector = (state: any, props: { style?: React.CSSProperties }) => props.style;
export const makeStyleSelector = (): SettingsPropsParametricSelector => {
  const outerWidthSelector = getSettingValueSelector(TargetSelector.Entity, "outerWidth");

  return createShallowEqualSelector(
    [outerWidthSelector, stylePropsSelector],
    (outerWidth, style): React.CSSProperties => ({
      maxWidth: outerWidth,
      width: "100%",
      ...style
    })
  );
};
